<template>
  <div :class="['anno',this.maskShow ? '':'row']">
    <div v-wechat-title="$route.meta.title"></div>
    <div class="container">
      <div class="room-tips">
          <p>تعال والعب معنا أمونج آس</p>
          <img :src="headImg" class="userImg"/>
      </div>
      <div class="contents">
        <div class="contentView">
          <div class="swiper-container" ref="Myswper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="zong_zi_1">
                </div>
              </div>
              <div class="swiper-slide">
                <div class="zong_zi_2">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="room-home">
        <div class="bubble-box bubble-box-left" v-show="mySwiper.realIndex==0">
            <p class="up" v-if="leftNum>=1"></p>
            <p class="down" v-if="leftNum>=2"></p>
        </div>
        <div class="bubble-box bubble-box-right" v-show="mySwiper.realIndex==1">
            <p class="up" v-if="rightNum>=1"></p>
            <p class="down" v-if="rightNum>=2"></p>
        </div>
      </div>
    </div>
    <div class="tips"
         :class="{on:tips!=''}"
         v-if="tips!=''">
      <p>{{ tips }}</p>
    </div>
    <div :class="['footerView', toBottom == true ? 'footerView1': '']" ref="bottomView">
      <button class="clickBtn" id="downloadButton">تحميل</button>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import Header from './Header'
import { Params, getSessionId, getUid, browser, setSessionId } from '../util/util.js'
import loadImg from '../assets/load_image.png'
import Qs from 'qs'
let Base64 = require('js-base64').Base64
export default {
  name: 'AmongUsShare',
  data () {
    return {
      mySwiper: {},
      giftName: this.$store.state.giftName,
      giftImgUrl: this.$store.state.giftImgUrl,
      tips: '',
      limitTime: this.$store.state.limitTime,
      maskShow: false,
      backToTop: false,
      myUid: 0,
      sessionid: getSessionId(),
      /* zongzi */
      animate: false,
      showMask: false,
      toSignRef: 'wevenus://user/sign', // 签到
      toVocalRef: 'wevenus://common/main?tab1=ccp&tab2=match', // 语音配/颜值配
      toMessageRef: 'wevenus://common/main?tab1=message&tab2=friend', // 接收匹配请求
      toNewRef: 'wevenus://common/main?tab1=bbs&tab2=new', // 帖子页
      toRechargeRef: 'wevenus://user/account', // 充值
      toGameRef: 'wevenus://room/gameList', // 游戏
      toRoomRef: 'wevenus://common/main?tab1=room&tab2=recommend', // 房间在线
      toMoveRef: 'wevenus://room/movieList', // 看电影
      toBottom: false,
      headImg: loadImg,
      nickName: 'XXX',
      leftNum: 0,
      rightNum: 0,
      animateTimer: null
    }
  },
  computed: {

  },
  mounted () {
    let that = this
    this.mySwiper = new Swiper('.swiper-container', {
      autoplay: 3500,
      autoplayDisableOnInteraction: false,
      direction: 'horizontal',
      slidesPerView: 'auto',
      centeredSlides: true,
      observer: true,
      observeParents: true,
      loop: true,
      onSlideChangeEnd: function (swiper) {
        var num = swiper.realIndex
        // console.log('当前页', num);
        clearInterval(that.animateTimer)
        that.animateTimer = setInterval(() => {
          if (num == 0) {
            that.rightNum = 0
            that.leftNum++
            that.leftNum == 2 ? clearInterval(that.animateTimer) : ''
          } else if (num == 1) {
            that.leftNum = 0
            that.rightNum++
            that.rightNum == 2 ? clearInterval(that.animateTimer) : ''
          }
        }, 600)
      }
    })
  },
  methods: {
    openApp () {
      if (browser.versions.ios) {
        // window.location.href = "com.baidu.tieba://"; //ios app协议
        // window.setTimeout(function() {
        //   window.location.href = "https://apps.apple.com/app/id1489566586"; // ios下载地址
        // }, 2000)
        window.location.href = 'https://apps.apple.com/app/id1489566586' // ios下载地址
      } else {
        // window.location.href = "mqqwpa://im/chat?chat_type=wpa&uin=479858761&version=1&src_type=web&web_src=oicqzone.com"
        // window.location.href = "com.baidu.tieba://app"; //Android app协议
        // window.location.href = "com.baidu.tieba://usercenter"; //Android app协议
        // window.setTimeout(function() {
        //   window.location.href = "https://play.google.com/store/apps/details?id=com.duiud.bobo"; // 安卓下载地址
        // }, 2000)
        window.location.href = 'https://play.google.com/store/apps/details?id=com.duiud.bobo' // ios下载地址
      }
    },
    weCallback: function (code, msg, requestCode) {
      // this.showTips('requestCode: '+ requestCode + 'msg: ' + msg, this)
      // if (requestCode === 1) {
      //   this.invoke()
      // }
      if (requestCode === 1) {
        let json = JSON.parse(msg)
        this.$store.commit('setLoginAccount', json)
        if (this.$store.state.userInfo.token) {
          // setSessionId(token.split(',')[0])
          setSessionId(this.$store.state.userInfo.token)
        }
        // this.invoke()
      } else {
        this.$children.forEach(item => {
          item.$emit('dispatchCallback', code, msg, requestCode)
        })
      }
    },
    showTips (tips, that) {
      that.tips = tips
      setTimeout(() => {
        that.tips = ''
      }, 1000)
    },
    scrollToTop () {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      // let browserHeight = window.outerHeight;
      // console.log('hhhh ', browserHeight)
      // if (scrollTop > browserHeight) {
      //   this.backToTop = true;
      // } else {
      //   this.backToTop = false;
      // }
    //   var scrollTop = document.documentElement.scrollTop||document.body.scrollTop
    //   var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
    //   var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
    //   var bottom = this.$refs.bottomView.clientHeight
    //   if(scrollTop+windowHeight+bottom>=scrollHeight){
    //     this.toBottom = true
    //   }else{
    //     this.toBottom = false
    //   }
    },
    toTop () {
      let back = setInterval(() => {
        if (document.body.scrollTop || document.documentElement.scrollTop) {
          document.body.scrollTop -= 100
          document.documentElement.scrollTop -= 100
        } else {
          clearInterval(back)
        }
      })
    },
    toPage (str) {
      if (window.weBridge.openPage) {
        window.weBridge.openPage(str)
      } else {
        this.showTips('当前版本过低，请升级到最新版', this)
      }
    },
    toRoom (roomid) {
      // var str = "we://user?uid="
      // if (window.weBridge.openPage) {
      //   // window.weBridge.openPage(str + roomid)
      //   window.weBridge.goUserPage(str, roomid)
      // } else {
      //   this.showTips("当前版本过低，请升级到最新版", this)
      // }
      var str = 'bobo://chatroom?roomId='
      var to = roomid
      window.location.href = str + to
    },
    // 跳个人资料页
    toInfo (uid) {
      // var str = "we://user?uid="
      var str = 'wevenus://user/info?uid='
      if (window.weBridge.openPage) {
        window.weBridge.openPage(str + uid)
      } else {
        this.showTips('当前版本过低，请升级到最新版', this)
      }
    }
  },
  components: {
    Header
  },
  created () {
    // this.invoke()
    let sessionId = getSessionId()
    this.sessionid = sessionId
    if ((!this.$store.state.userInfo || !sessionId) && window.weBridge && window.weBridge.getLocalUser) {
      window.weBridge.getLocalUser(1)
    } else {
      // this.invoke()
    }
    window.weCallback = (code, msg, requestCode) => {
      this.weCallback(code, msg, requestCode)
    }
    window.addEventListener('scroll', this.scrollToTop)

    // console.log(guideList1);
    this.headImg = guideList1.headImg ? guideList1.headImg : this.headImg
  }
}
</script>
<style scoped>
img{
  display: block;
}
button{
    outline: none;
    border: none;
}
.container{
    background-image: url('../assets/AmongUs/bg.png');
    background-size: 100%;
    /* width: 100%; */
    /* height: 10rem; */
    padding-top: 0.01rem;
    padding-bottom: 0.72rem;
    background-color: #010013;
}
.anno {
  position: relative;
  overflow: hidden;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  -webkit-touch-callout:none;
}
.tips{
  margin-top: 2rem;
}
.room-tips{
    position: relative;
    margin: 0.4rem auto 0.46rem;
    width: 2.46rem;
    height: 0.8rem;
    padding-right: 0.76rem;
    background: #01001C;
    border: 0.04rem solid #D8D3D9;
}
.room-tips::before{
    content: "";
    display: block;
    position: absolute;
    top: -0.38rem;
    left: -0.16rem;
    width: 0.52rem;
    height: 0.52rem;
    background: transparent url('../assets/AmongUs/bobo-icon.png') no-repeat;
    background-size: contain;
}
.room-tips p{
    font-size: 0.18rem;
    line-height: 0.8rem;
    text-align: right;
}
.userImg{
    position: absolute;
    right: 0.13rem;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
}
.contents{
  position: relative;
  width: 100%;
  margin-top: 0.13rem;
}
.contentView{
    position: relative;
    margin: 0 auto;
    width: 3.66rem;
    height: 4.03rem;
    /* background-color: #FFFFFF; */
    /* border: 0.06rem solid #040307; */
    /* border-radius: 0.08rem; */
    /* box-sizing: border-box; */
    z-index: 50;
}
.contentView::before{
    content: "";
    display: block;
    position: absolute;
    top: -0.78rem;
    left: -0.06rem;
    width: 3.45rem;
    height: 1.2rem;
    background: transparent url('../assets/AmongUs/the_impostor.png') no-repeat;
    background-size: contain;
    z-index: 10;
}
.zong_zi_1,
.zong_zi_2{
  background-position: center;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 3.66rem;
  height: 4.03rem;
  /* margin-left: 0.05rem; */
}
.swiper-slide{
  transform-style:preserve-3d;
  backface-visibility:hidden;
  /* transition:1s; */
}
.zong_zi_1{
  background-image: url('../assets/AmongUs/carousel_first.png');
  background-size: contain;
}
.zong_zi_2{
  background-image: url('../assets/AmongUs/carousel_second.png');
}
.room-home{
    position: relative;
    margin: -0.85rem auto 0;
    width: 3.66rem;
    height: 4.92rem;
    background: transparent url('../assets/AmongUs/home_page.png') no-repeat;
    background-size: contain;
    z-index: 10;
    /* margin-left: 0.12rem; */
}
.bubble-box .up, .bubble-box .down{
    position: absolute;
    width: 1.23rem;
    height: 0.51rem;
}
.bubble-box .up{
    background: transparent url('../assets/AmongUs/not_me_up.png') no-repeat;
    background-size: contain;
    animation: bubbleShow1 0.3s;
}
.bubble-box .down{
    background: transparent url('../assets/AmongUs/not_me_down.png') no-repeat;
    background-size: contain;
    animation: bubbleShow2 0.3s;
}
@keyframes bubbleShow1 {
    0%{
        opacity: 0;
        transform: translateY(-8px);
    }
    100%{
        opacity: 1;
        transform: translateY(0px);
    }
}
@keyframes bubbleShow2 {
    0%{
        opacity: 0;
        transform: translateY(8px);
    }
    100%{
        opacity: 1;
        transform: translateY(0px);
    }
}
.bubble-box-left .up{
    top: 1.22rem;
    left: 0.3rem;
}
.bubble-box-right .up{
    top: 1.22rem;
    right: 0.64rem;
}
.bubble-box-right .down{
    bottom: 1.94rem;
    right: 0.12rem;
}
.bubble-box-left .down{
    bottom: 1.91rem;
    left: 0.64rem;
}
.clickBtn{
    width: 3.4rem;
    height: 0.48rem;
    background: #FFDA00;
    border-radius: 0.24rem;
    color: #01001B;
    font-size: 0.22rem;
}

.bottomView{
  display: none;
  margin: 0 auto;
  margin-bottom: 0.14rem;
  width: 2.98rem;
  height: 0.56rem;
  border-radius: 0.31rem;
  box-sizing: border-box;
  border: 1px dashed rgba(250, 204, 103, 0.9);
}
.inviteInfo{
  margin-left: 0.1rem;
  margin-top: 0.11rem;
  width: 2.2rem;
  font-size: 0.14rem;
  color: #0E0F16;
  font-family: Avenir-Heavy;
  line-height: 0.22rem;
  text-align: left;
}
.nickNameView{
  display: inline-block;
  vertical-align: middle;
  min-width: 0;
  max-width: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* .banner{
  width: 100%;
  height: 3.75rem;
  background-image: url('../assets/first_figure_img.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
} */
.notice{
  /* opacity: 0.5;
  background: #0C4608; */
  background: rgba(12, 70, 8, .5);
  border-radius: 0.21rem;
  border-radius: 0.21rem;
  height: 0.36rem;
  width: 3rem;
  position: relative;
  top: 3.39rem;
  left: 0.38rem;
  overflow: hidden;
}
.marquee_list {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}
.marquee_text{
  min-width: 0;
  max-width: 0.58rem;
  height: 0.36rem;
  line-height: 0.36rem;
  color: #F8E71C;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.marquee_list span{
  display: inline-block;
  vertical-align: middle;
  line-height: 0.36rem;
}
.marquee_top {
  transition: all 0.5s;
  margin-top: -0.36rem;
}
.marquee_list li {
  height: 0.36rem;
  font-size: 0.14rem;
  padding-left: 0.24rem;
  list-style: none;
  width: 2.5rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bagView{
  position: absolute;
  right: 0;
  top: 2.75rem;
  /* opacity: 0.6;
  background: #0C4608; */
  background: rgba(12, 70, 8, .6);
  border-radius: 1rem 0 0 1rem;
  width: 0.75rem;
  height: 0.34rem;
  display: flex;
  align-items: center;
}
.bagView img{
  width: 0.23rem;
  height: 0.2rem;
  margin-left: 0.11rem;
}
.bagView p{
  font-size: 0.14rem;
  color: #FFFFFF;
  margin-left: 0.04rem;
}
.swiper-container {
  /* background-color: rgb(138, 226, 226); */
  z-index: 0;
  width: 100%;
  /* padding-top: 0.2rem;
  padding-bottom: 0.24rem; */
  /* margin-top: 0.2rem;
  margin-bottom: 0.24rem; */
}
/* .swiper-wrapper{
  border
} */
.swiper-slide {
  /* background-position: center; */
  background-size: contain;
  /* width: 100%; */
  width: 3.66rem;
  height: 100%;
  background-color: transparent;
  /* margin-left: -0.01rem; */
  /* margin-left: 0.24rem; */
}
/* .swiper-slide:first-child{
  margin-left: 0.02rem;
  margin-right: 0.12rem;
}
.swiper-slide+.swiper-slide{
  margin-left: 0;
  margin-right: 0.12rem;
} */
.swiper-slide-next,
.swiper-slide-prev{
    /* opacity: 0.5; */
}
.lineSwiper{
  display: flex;
  align-items: center;
  width: fit-content;
  margin: 0 auto;
  margin-top: 0.12rem;
}
.p1{
  width: 0.24rem;
  height: 0.04rem;
  border-top-left-radius: 0.02rem;
  border-bottom-left-radius: 0.02rem;
  background-color: rgba(255, 255, 255, .4);
}
.p2{
  width: 0.23rem;
  height: 0.04rem;
  background-color: rgba(255, 255, 255, .4);
}
.p3{
  width: 0.24rem;
  height: 0.04rem;
  border-top-right-radius: 0.02rem;
  border-bottom-right-radius: 0.02rem;
  background-color: rgba(255, 255, 255, .4);
}
.pSelect{
  background-color: #FFFFFF;
}
.footerView{
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #000000;
  height: 0.72rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}
.footerView1{
  background-color: transparent;
}
.clickBtn:active{
  filter: brightness(0.9);
}
.rote{
  animation: page 1s 1 ease-in-out;
  /* display: none; */
  -webkit-animation: page 1s 1 ease-in-out forwards;
}
.rote2{
  animation: page2 1s 1 ease-in-out;
  -webkit-animation: page2 1s 1 ease-in-out forwards;
}
@keyframes page {
    0% {
      transform: rotateY(0deg);
      opacity: 1;
    }
    /* 50% {
      transform: rotateY(-90deg);
      opacity: 0;
    } */
    100% {
      transform: rotateY(-180deg);
      opacity: 0;
    }
}
@keyframes page2 {
    0% {
      transform: rotateY(-180deg);
      opacity: 0;
    }
    /* 0% {
      transform: rotateY(-90deg);
      opacity: 1;
    } */
    100% {
      transform: rotateY(0deg);
      opacity: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/AmongUsShare.vue